





































































































import { Component, Prop } from 'vue-property-decorator';
import {
  MoreHorizontalIcon,
  PaperclipIcon,
  MessageSquareIcon,
  CalendarIcon,
} from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import { IDamage, DamageStatus } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import dayjs from 'dayjs';
import ProductBadge from '@/components/common/ProductBadge.vue';

@Component({
  components: {
    ProductBadge,
    MessageSquareIcon,
    CalendarIcon,
    MoreHorizontalIcon,
    Avatar,
    PaperclipIcon,
  },
})
export default class KanbanItem extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: Object, required: true })
  damage!: IDamage;

  showHeader = false;

  get isOverdue() {
    if (!this.damage.dueAt) return false;

    // Nur bei aktiven Status-Werten die Warning-Farbe anzeigen
    const activeStatuses = [
      DamageStatus.NEW,
      DamageStatus.IN_PROGRESS,
      DamageStatus.PENDING,
      DamageStatus.SUBMITTED,
    ];

    if (!activeStatuses.includes(this.damage.status)) return false;

    return dayjs(this.damage.dueAt).isBefore(dayjs(), 'day');
  }

  formatDate(date: Date | string | undefined) {
    if (!date) return '';
    return dayjs(date).format('DD.MM.YY');
  }
}
